import { createTypeGroupList } from "./utils";
import { TEAM_CA, MEDAL } from "./constants";

const includesTeamCA = (arr) => arr.includes(TEAM_CA);
const includesMedal = (arr) => arr.includes(MEDAL);
const isType = (obj) => obj && Array.isArray(obj.typ);
const includesType = (type) => (obj) => isType(obj) && obj.typ.includes(type);
const includesPlatform = (platform) => (obj) =>
    obj && Array.isArray(obj.on) && obj.on.includes(platform);
const includesOlympics = (filter) => (obj) =>
    obj && Array.isArray(obj.oly) && filter(obj.oly);
const includesTypes = (types) => (obj) =>
    isType(obj) && types.some((type) => obj.typ.includes(type));
const excludeTypes = (types) => (obj) => !includesTypes(types)(obj);

const filterByEvent = (types, eventType) => {
    const eventTypeFilter = eventType && includesType(eventType);
    types = createTypeGroupList(types);
    const typeFilter = types.length > 0 && includesTypes(types);
    const eventTypeAndTypeFilter = (obj) => {
        if (eventTypeFilter(obj)) {
            // one, or all types are eventType
            if (obj.typ.every((str) => str === eventType)) {
                return true;
            }
            return typeFilter(obj);
        }
        return false;
    };
    return eventTypeFilter && typeFilter
        ? eventTypeAndTypeFilter
        : eventTypeFilter
        ? eventTypeFilter
        : typeFilter;
};

const filterScheduleData = (
    scheduleData,
    { platform, types, isTeamCanada, isMedal, eventType, ignoreTypes },
    filterBy
) => {
    const hasEventTypeOrType = eventType || types;
    return [
        [platform, includesPlatform(platform)],
        [hasEventTypeOrType, filterByEvent(types, eventType)],
        [isTeamCanada, includesOlympics(includesTeamCA)],
        [isMedal, includesOlympics(includesMedal)],
        [filterBy, filterBy],
        [ignoreTypes, excludeTypes(createTypeGroupList(ignoreTypes))],
    ].reduce((arr, [param, filter]) => {
        return param ? arr.filter(filter) : arr;
    }, scheduleData);
};

export {
    filterScheduleData,
    includesPlatform,
    includesType,
    includesTeamCA,
    includesMedal,
    isType,
    includesOlympics,
};
